import styled from 'styled-components'
import Breakpoints from '../../theme/breakpoints'
import Colors from '../../theme/colors'
import Fonts from '../../theme/fonts'

export const Heading = styled.h2`
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0.01em;
  color: ${Colors.Primary.GreyText};
  font-size: ${Fonts.fontSizes.p24};
  font-family: ${Fonts.fontFamilies.Montserrat};
  margin-bottom: 0;
`

export const Content = styled.div`
  font-family: ${Fonts.fontFamilies.Inter};
  font-size: ${Fonts.fontSizes.p16};
  font-weight: ${Fonts.fontWeights.medium};
  line-height: 16px;
  letter-spacing: 0.01em;
  text-align: left;
  background: ${Colors.Primary.White};
  border: 1px solid ${Colors.Primary.GreyLight};
  box-sizing: border-box;
  border-radius: 16px;
  padding: 48px;
  @media (max-width: ${Breakpoints.tablet}) {
    padding: 16px;
  }
  margin: 32px 0 64px 0;
`

export const Row = styled.div`
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
